export { default as RateCalculatorTemplate } from './RateCalculatorTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/rate-calculator/pages/index.js